import {useEffect, useRef} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {
    DSA_RATING_SORT_AB_TEST_ID,
    DSA_RATING_SORT_CONTROL_VARIANT,
    DSA_RATING_SORT_TREATMENT_VARIANT,
    isDsaRatingSortTreatmentVariant
} from "../../ab_testing/dsa_rating_sort_ab_test";

export const useDsaRatingSortExperiment = () => {
    const hasTrackedExposureRef = useRef(false);
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: DSA_RATING_SORT_AB_TEST_ID,
        variants: [DSA_RATING_SORT_CONTROL_VARIANT, DSA_RATING_SORT_TREATMENT_VARIANT],
        withSSR: true,
        pushEventOnlyOnce: true
    });
    const hasAssignedVariant =
        canABTestBeRendered && (abTestVariant === DSA_RATING_SORT_CONTROL_VARIANT || abTestVariant === DSA_RATING_SORT_TREATMENT_VARIANT);

    useEffect(() => {
        if (!hasAssignedVariant || hasTrackedExposureRef.current) {
            return;
        }

        hasTrackedExposureRef.current = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(DSA_RATING_SORT_AB_TEST_ID));
    }, [hasAssignedVariant]);

    return {
        useDsaRatingSort: hasAssignedVariant && isDsaRatingSortTreatmentVariant(abTestVariant),
        variant: abTestVariant
    };
};
import {useEffect, useRef} from "react";

import {useABTest} from "@pg-mono/ab-testing";
import {trackAmplitudeExperimentExposure, waitForAmplitudeInitialization} from "@pg-mono/amplitude";

import {
    DSA_RATING_SORT_AB_TEST_ID,
    DSA_RATING_SORT_CONTROL_VARIANT,
    DSA_RATING_SORT_TREATMENT_VARIANT,
    isDsaRatingSortTreatmentVariant
} from "../../ab_testing/dsa_rating_sort_ab_test";

export const useDsaRatingSortExperiment = () => {
    const hasTrackedExposureRef = useRef(false);
    const {canABTestBeRendered, abTestVariant} = useABTest({
        id: DSA_RATING_SORT_AB_TEST_ID,
        variants: [DSA_RATING_SORT_CONTROL_VARIANT, DSA_RATING_SORT_TREATMENT_VARIANT],
        withSSR: true,
        pushEventOnlyOnce: true
    });
    const hasAssignedVariant =
        canABTestBeRendered && (abTestVariant === DSA_RATING_SORT_CONTROL_VARIANT || abTestVariant === DSA_RATING_SORT_TREATMENT_VARIANT);

    useEffect(() => {
        if (!hasAssignedVariant || hasTrackedExposureRef.current) {
            return;
        }

        hasTrackedExposureRef.current = true;

        void waitForAmplitudeInitialization()
            .catch(() => undefined)
            .finally(() => trackAmplitudeExperimentExposure(DSA_RATING_SORT_AB_TEST_ID));
    }, [hasAssignedVariant]);

    return {
        useDsaRatingSort: hasAssignedVariant && isDsaRatingSortTreatmentVariant(abTestVariant),
        variant: abTestVariant
    };
};
